//#region DevExtreme Imports

import 'devextreme/ui/form'

//#endregion

import { ORDER_SERVICE_NAME, ORDER_ADD_SERVICE_NAME } from "../../../../services/order"
import { USER_SESSION_SERVICE_NAME } from "../../../../services/user-session"
import { SELECT_BOX_CONTROLS_SERVICE_NAME, VALIDATION_CONTROLS_SERVICE_NAME } from "../../../../services/controls"

import { OrderAddController } from "./add-order.controller"

//#region Asset Imports

import * as TEMPLATE from './add-order.tpl.html'
import './add-order.scss'

//#endregion

export const COMPONENT_NAME: string = 'ordersAddOrder'

export class OrderAddComponent {

    controller = [
        ORDER_SERVICE_NAME,
        ORDER_ADD_SERVICE_NAME,
        SELECT_BOX_CONTROLS_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        VALIDATION_CONTROLS_SERVICE_NAME,
        OrderAddController
    ]

    bindings = {
        options: '<',
    } as { [index: string]: string }

    template = TEMPLATE

}